import { useMutation } from 'react-query';
import { 
  selfRegister,
  selfRegisterGetResendToken,
  selfRegisterPostResendToken,
  selfRegisterGetValidateAccount,
  selfRegisterPostValidateAccount, 
} from 'api/register';

import { SelfRegisterParams } from '../types';

export const useSelfRegister = () => {

  return useMutation((params: SelfRegisterParams) => selfRegister(params));

}

export const useSelfRegisterGetResendToken = () => {

  return useMutation((params: {newEmail?: string, registeredEmail: string}) => selfRegisterGetResendToken(params));

}
export const useSelfRegisterPostResendToken = () => {

  return useMutation((params: {newEmail?: string, registeredEmail: string}) => selfRegisterPostResendToken(params));

}
export const useSelfRegisterGetValidateAccount = () => {

  return useMutation((params: {token: string}) => selfRegisterGetValidateAccount(params));

}
export const useSelfRegisterPostValidateAccount = () => {

  return useMutation((params: {token: string}) => selfRegisterPostValidateAccount(params));

}